import type {TicketingQuestion} from '@Components/event-wizard/event-wizard-ticketing/event-wizard-ticketing.types';

export type TicketingQuestionEditorMode = 'add' | 'edit';

export interface TicketingQuestionEditorProps {
  draft: TicketingQuestion;
  mode: TicketingQuestionEditorMode;
  displayNumber: number;
  onDraftChange: (draft: TicketingQuestion) => void;
  onCommit: () => void;
  onCancel: () => void;
}

/**
 * A choice-type option row in the editor's local state. Carries a stable `id` so React keys survive
 * deletes/reorders — `InputField` seeds its internal value once from `input`, so index keys would
 * surface a stale value after a row is removed or moved. The draft's persisted `options` is just the
 * projected `value[]`; `type` is intentionally not co-located here.
 */
export interface TicketingOptionRow {
  id: string;
  value: string;
}

export const TICKETING_OPTION_DRAG_HANDLE = 'ticketing-option-drag-handle';
